import React from 'react';
import {message} from 'antd';

export default ({
                    type = 'success',
                    icon,
                    text,
                    className,
                    duration = 3,
                    key = parseInt(Math.random() * 1000000)
                }) => {
    const TYPES = {
        success: 0,
        error: 1,
        info: 2,
        warning: 3,
        normal: 4,
        ghost: 5,
    };
    const BACKGROUND_COLORS = {
        [TYPES.success]: 'ant-message-bg-success',
        [TYPES.error]: 'ant-message-bg-error',
        [TYPES.info]: 'ant-message-bg-info',
        [TYPES.warning]: 'ant-message-bg-warning',
    };

    const ICONS = {
        [TYPES.success]: <img src={'/images/icons/announce-success.svg'}/>,
        [TYPES.warning]: <img src={'/images/icons/announce-warning.svg'}/>,
        [TYPES.info]: <img src={'/images/icons/announce-info.svg'}/>,
        [TYPES.error]: <img src={'/images/icons/announce-error.svg'}/>,
    };

    switch (type) {
        case 'success':
            message.success({
                key: key,
                content: text,
                className: BACKGROUND_COLORS[TYPES[type]],
                icon: ICONS[TYPES[type]],
                onClick: el => message.destroy(key),
                duration
            })
            break;
        case 'warning':
            message.warning({
                key: key,
                content: text,
                className: BACKGROUND_COLORS[TYPES[type]],
                icon: ICONS[TYPES[type]],
                onClick: el => message.destroy(key),
                duration
            })
            break;
        case 'error':
            message.error({
                key: key,
                content: text,
                className: BACKGROUND_COLORS[TYPES[type]],
                icon: ICONS[TYPES[type]],
                onClick: el => message.destroy(key),
                duration
            })
            break;
        case 'info':
            message.info({
                key: key,
                content: text,
                className: BACKGROUND_COLORS[TYPES[type]],
                icon: ICONS[TYPES[type]],
                onClick: el => message.destroy(key),
                duration
            })
            break;
    }
}